module.exports = __webpack_public_path__ + "img/img_level_17.122fe058.png";